const M = [
  {
    name: "personalCenter",
    zh: "个人中心",
    en: "Personal"
  },
  {
    name: "messageCenter",
    zh: "消息中心",
    en: "Message"
  },
  {
    name: "myAddress",
    zh: "我的地址",
    en: "My address"
  },
  {
    name: "coupon",
    zh: "优惠券",
    en: "Coupon"
  },
  {
    name: "invitationAwards",
    zh: "邀请有奖",
    en: "Invitation with awards"
  },
  {
    name: "securitySet",
    zh: "安全设置",
    en: "Security setting"
  },
  {
    name: "commonSet",
    zh: "通用设置",
    en: "Common setting"
  },
  {
    name: "versionDescription",
    zh: "版本说明",
    en: "Version description"
  },
  {
    name: "giveFeedback",
    zh: "帮助反馈",
    en: "Feedback"
  },
  {
    name: "quit",
    zh: "退出",
    en: "Quit"
  },
  {
    name: "sureQuit",
    zh: "您确定要退出吗？",
    en: "Are you sure to quit?"
  },
  {
    name: "personalInformation",
    zh: "个人资料",
    en: "Personal information"
  },
  {
    name: "modify",
    zh: "修改",
    en: "Modify"
  },
  {
    name: "modifyAvatar",
    zh: "修改头像",
    en: "Modify avatar"
  },
  {
    name: "avatar",
    zh: "头像",
    en: "Avatar"
  },
  {
    name: "uploadAvatar",
    zh: "上传头像",
    en: "Upload avatar"
  },
  {
    name: "selectAvatar",
    zh: "请选择头像",
    en: "Select avatar"
  },
  {
    name: "selectMobilePhoto",
    zh: "从手机相册选择",
    en: "Choose from phone album"
  },
  {
    name: "modifyNickname",
    zh: "修改昵称",
    en: "Modify nickname"
  },
  {
    name: "nickname",
    zh: "昵称",
    en: "Nickname"
  },
  {
    name: "eepayAccount",
    zh: "易付宝账号",
    en: "eepay account"
  },
  {
    name: "personalMessage",
    zh: "个人消息",
    en: "Personal message"
  },
  {
    name: "systemMessage",
    zh: "系统消息",
    en: "System message"
  },
  {
    name: "messageDetails",
    zh: "消息详情",
    en: "Message detail"
  },
  {
    name: "shippingAddress",
    zh: "收货地址",
    en: "Shipping address"
  },
  {
    name: "management",
    zh: "管理",
    en: "Management"
  },
  {
    name: "noAddressTips",
    zh: "您还没有添加收货地址，点击右上角新增地址",
    en:
      "You have not added the shipping address, click on the top right corner to add the address"
  },
  {
    name: "selectShippingAddress",
    zh: "选择收货地址",
    en: "Select shipping address"
  },
  {
    name: "newAddress",
    zh: "新增地址",
    en: "New address"
  },
  {
    name: "enterShippingAddress",
    zh: "请输入您的收货地址",
    en: "Enter your shipping address"
  },
  {
    name: "currentLocation",
    zh: "当前定位",
    en: "Current location"
  },
  {
    name: "reLocate",
    zh: "重新定位",
    en: "Re-locate"
  },
  {
    name: "myShippingAddress",
    zh: "我的收货地址",
    en: "My shipping address"
  },
  {
    name: "contactPerson",
    zh: "联系人",
    en: "Name"
  },
  {
    name: "fillConsigneeName",
    zh: "请填写收货人姓名",
    en: "Fill contact name"
  },
  {
    name: "contact",
    zh: "联系方式",
    en: "Phone number"
  },
  {
    name: "fillReceivingPhone",
    zh: "请填写收货人手机号码",
    en: "Fill phone number"
  },
  {
    name: "houseNumber",
    zh: "门牌号",
    en: "Detail address"
  },
  {
    name: "fillDetailAddress",
    zh: "请填写详细地址",
    en: "Fill detail address"
  },
  {
    name: "sureDeleteAddress",
    zh: "确定删除地址？",
    en: "Are you sure to delete the address?"
  },
  {
    name: "nearbyAddress",
    zh: "附近地址",
    en: "Nearby address"
  },
  {
    name: "modifyAddress",
    zh: "修改地址",
    en: "Modify address"
  },
  {
    name: "saveAddress",
    zh: "保存地址",
    en: "Save address"
  },
  {
    name: "multiLanguage",
    zh: "多语言",
    en: "Multi-language"
  },
  {
    name: "languageSwitch",
    zh: "语言切换",
    en: "Language switch"
  },
  {
    name: "commonProblem",
    zh: "常见问题",
    en: "FAQ"
  },
  {
    name: "helpChange",
    zh: "换一换",
    en: "Other questions"
  },
  {
    name: "suggestionsOpinions",
    zh: "您的建议与意见",
    en: "Suggestions and opinions"
  },
  {
    name: "enterSuggestionsOpinions",
    zh: "请输入您的建议与意见",
    en: "Enter Suggestions and comments"
  },
  {
    name: "onlySupportsFormat",
    zh: "仅支持JPG、GIF、PNG、JPEG、BMP格式",
    en: "Only supports JPG, GIF, PNG, JPEG, BMP format"
  },
  {
    name: "picSizeTips",
    zh: "图片大小不能超过",
    en: "The picture size should not exceed"
  }
];

export default M;
